export default "__VITE_ASSET__c3c5202f__"